import TableCellLink from "ds/components/Table/Row/CellLink";
import TableCellText from "ds/components/Table/Row/CellText";

import { getModulePullRequestSingleRun } from "../../../helpers";
import { ModulePullRequestsTablePullRequestCellProps } from "../types";
import ModulePullRequestsTableGroupCell from "../../GroupCell";

const ModulePullRequestsTablePullRequestTitleCell = ({
  item: pullRequest,
  moduleId,
  ...cellProps
}: ModulePullRequestsTablePullRequestCellProps) => {
  const singleRun = getModulePullRequestSingleRun(pullRequest.runs);

  return (
    <ModulePullRequestsTableGroupCell item={pullRequest} {...cellProps} role="rowheader">
      {!!singleRun && (
        <TableCellLink
          href={`/module/${moduleId}/run/${singleRun.id}`}
          routerOptions={{ state: { prUrl: pullRequest.url, prTitle: pullRequest.title } }}
        >
          {singleRun.expectFailure ? `${pullRequest.title} (should fail)` : pullRequest.title}
        </TableCellLink>
      )}

      {!singleRun && <TableCellText>{pullRequest.title}</TableCellText>}
    </ModulePullRequestsTableGroupCell>
  );
};

export default ModulePullRequestsTablePullRequestTitleCell;
